module.exports = __webpack_public_path__ + "img/info7.457e8b56.svg";